/* MOWOW Impact: robots mega-menu tabs */
function mowowSetActiveTab(root,tabId){
  root.querySelectorAll('[data-mowow-tab]').forEach((tab)=>{
    tab.setAttribute('aria-selected',tab.getAttribute('data-mowow-tab')===tabId?'true':'false');
  });
  root.querySelectorAll('[data-mowow-panel]').forEach((panel)=>{
    panel.setAttribute('aria-hidden',panel.getAttribute('data-mowow-panel')===tabId?'false':'true');
  });
}
function initMowowRobotsMegaMenuTabs(){
  document.querySelectorAll('[data-mowow-robots-mega]').forEach((root)=>{
    if(root.dataset.mowowInit==='1') return;
    root.dataset.mowowInit='1';
    const def=root.getAttribute('data-default-tab')||'luba';
    mowowSetActiveTab(root,def);
    const handler=(ev)=>{
      const btn=ev.target && ev.target.closest ? ev.target.closest('[data-mowow-tab]') : null;
      if(!btn) return;
      if(ev.type==='click') ev.preventDefault();
      mowowSetActiveTab(root,btn.getAttribute('data-mowow-tab'));
    };
    root.addEventListener('mouseover',handler);
    root.addEventListener('focusin',handler);
    root.addEventListener('click',handler);
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initMowowRobotsMegaMenuTabs);}else{initMowowRobotsMegaMenuTabs();}
document.addEventListener('shopify:section:load',initMowowRobotsMegaMenuTabs);

/* MOWOW 05.10.2026: legaturile din antet aveau aria-controls spre sertare care nu exista pe pagina.
   Cosul e de tip popover (fara #cart-drawer), iar sectiunea de cautare nu e in grupul de suprapuneri
   (fara #search-drawer), deci atributul arata spre nimic (Lighthouse aria-valid-attr-value). Linkurile
   duc oricum la /cart si /search. Atributul se scoate doar daca tinta chiar lipseste: daca sertarul
   revine in tema, legatura ramane neatinsa. */
function mowowCurataAriaControlsAntet(){
  document.querySelectorAll('.header [aria-controls="search-drawer"], .header [aria-controls="cart-drawer"]').forEach((el)=>{
    if(!document.getElementById(el.getAttribute('aria-controls'))) el.removeAttribute('aria-controls');
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mowowCurataAriaControlsAntet);}else{mowowCurataAriaControlsAntet();}
document.addEventListener('shopify:section:load',mowowCurataAriaControlsAntet);
